import React from 'react';
import { Box, FormControlLabel } from '@mui/material';
import Button from '@material-ui/core/Button';

import { Field, FieldArray } from 'formik';
import FieldWrapper from '../../../../../components/common/formikWrappers/FieldWrapper';

import { ClassNameMap } from '@material-ui/core/styles/withStyles';

import TranslationHelper from '../../../../../helpers/TranslationHelper';
import { FormikErrors } from 'formik';
import { IAttributesForm } from './AttributesForm';
import CheckboxWrapper from '../../../../common/formikWrappers/CheckboxWrapper';
import { IDictionaryItem } from '../../../../../features/Attributes/state';
import {
    DIGITS_ONLY_REGEX,
    DOUBLE_REGEX,
} from '../../../../../constants/regex';

interface IOwnProps {
    formValues: IAttributesForm;
    errors: FormikErrors<IAttributesForm>;
    classes: ClassNameMap<'field'>;
    handleFormChange: (name: string, value: string | number | boolean) => void;
    inputType: string;
    editMode: boolean;
}
interface IDictionaryItemWithNewStatus extends IDictionaryItem {
    isNew?: boolean;
}

export const DictionaryWrapper = ({
    formValues,
    errors,
    inputType,
    editMode,
    handleFormChange,
}: IOwnProps) => {
    const handleChange = (e: any, name: string) => {
        const val = e.target.value;
        if (
            val !== '' &&
            ((inputType === 'Double' && !DOUBLE_REGEX.test(val)) ||
                (inputType === 'Integer' && !DIGITS_ONLY_REGEX.test(val)))
        ) {
            return;
        }
        handleFormChange(name, val);
    };
    return (
        <FieldArray name="dictionary" validateOnChange={false}>
            {({ push }) => (
                <>
                    &nbsp;&nbsp;
                    {formValues.dictionary.map((item, index) => {
                        const itemWithNewStatus =
                            item as IDictionaryItemWithNewStatus;
                        return (
                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: 2,
                                    mb: 2,
                                }}
                                key={index}
                            >
                                <FormControlLabel
                                    label={
                                        <span style={{ fontSize: '0.75rem' }}>
                                            {TranslationHelper.translate(
                                                'Active'
                                            )}
                                        </span>
                                    }
                                    labelPlacement="top"
                                    control={
                                        <Field
                                            name={`dictionary[${index}].active`}
                                            label={TranslationHelper.translate(
                                                'Active'
                                            )}
                                            component={CheckboxWrapper}
                                            required={true}
                                            style={{
                                                flex: '0 0 auto',
                                            }}
                                        />
                                    }
                                />
                                <Field
                                    error={
                                        !!(
                                            errors?.dictionary &&
                                            errors?.dictionary[index]?.name
                                        )
                                    }
                                    helperText={
                                        errors?.dictionary?.[index]?.name
                                    }
                                    name={`dictionary[${index}].name`}
                                    label={TranslationHelper.translate('Code')}
                                    component={FieldWrapper}
                                    required={true}
                                    disabled={
                                        editMode && !itemWithNewStatus?.isNew
                                    }
                                    style={{
                                        flex: '0 0 20%',
                                    }}
                                />
                                <Field
                                    error={
                                        !!(
                                            errors?.dictionary &&
                                            errors?.dictionary[index]?.value
                                        )
                                    }
                                    helperText={
                                        errors?.dictionary?.[index]?.value
                                    }
                                    name={`dictionary[${index}].value`}
                                    label={TranslationHelper.translate('Value')}
                                    component={FieldWrapper}
                                    onChange={(e: any) =>
                                        handleChange(
                                            e,
                                            `dictionary[${index}].value`
                                        )
                                    }
                                    required={true}
                                    style={{
                                        flex: '0 0 20%',
                                    }}
                                />
                                <Field
                                    error={
                                        !!(
                                            errors?.dictionary &&
                                            errors?.dictionary[index]?.label
                                        )
                                    }
                                    helperText={
                                        errors?.dictionary?.[index]?.label
                                    }
                                    name={`dictionary[${index}].label`}
                                    label={TranslationHelper.translate('Label')}
                                    component={FieldWrapper}
                                    required={true}
                                    style={{
                                        flex: '0 0 40%',
                                    }}
                                />
                            </Box>
                        );
                    })}
                    &nbsp;
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 2,
                            mb: 2,
                            justifyContent: 'flex-end',
                        }}
                    >
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={() => {
                                push({
                                    name: '',
                                    value: '',
                                    label: '',
                                    active: true,
                                    isNew: true,
                                });
                            }}
                        >
                            {TranslationHelper.translate('Add')}
                        </Button>
                    </Box>
                </>
            )}
        </FieldArray>
    );
};
